import { mapKeys } from 'lodash-es';

export const ROUTE = 1;
export const SERVICE = 2;

export const VEHICLE_ROLE_TYPES = mapKeys([{ id: ROUTE }, { id: SERVICE }], 'id');
